<div class="router-bar">
	<div class="route-button">
		<button mat-button [routerLink]="['/orders/list']">Orders</button>
	</div>
	<div class="route-button current-route">
		<button mat-button [routerLink]="['/orders/vendors']">Vendors</button>
	</div>
	<div class="route-button">
		<button mat-button [routerLink]="['/orders/materials']">Materials</button>
	</div>
</div>

<div class="board-header">
	<div class="board-bar">
		<div class="board-input">
			<span class="p-input-icon-right">
				<i class="pi pi-times cross-icon" (click)="resetVendors()" *ngIf="searchString?.length > 0"></i>
				<input pInputText BlockLateralArrowNavigation class="text-input" autocomplete="off" placeholder="Search Vendors" type="text"
					[(ngModel)]="searchString" name="name" (input)="topSearchBar()">
			</span>
		</div>
	</div>

</div>

<p-table #dt [value]="vendors" [paginator]="true" [rows]="projectsPerPage" [totalRecords]="totalElements"
	selectionMode="single" (onRowSelect)="openVendor($event)" [loading]="loadingProjects">
	<ng-template pTemplate="header" let-columns>
		<tr>
			<th *ngFor="let col of cols">
				{{col.header}}
			</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-rowData let-columns="cols">
		<tr [pSelectableRow]="rowData">
			<td *ngFor="let col of cols">
				<ng-container>
					<div class="table-div">{{getFieldData(rowData, col)}}</div>
				</ng-container>
			</td>
		</tr>
	</ng-template>
</p-table>
